// extracted by mini-css-extract-plugin
export default {"cobertura":"PassosPosAcao_cobertura__+3GsT"};